import { z } from "zod";
import { productSchema } from "./enumerations";

export const previousProductSchema = z.object({
  id: z.number(),
  name: z.string(),
  pricelistValidTo: z.number().optional(),
  product: productSchema.optional(),
  bundleService: z.string().nullable().default(null),
});
